import SvgSprite from '@/components/atomic/atoms/data-display/icons/icon-sprite/styled';
import FlexContainer from '@/components/atomic/atoms/layout/flex-container/styled';
import FlexItem from '@/components/atomic/atoms/layout/flex-item/styled';
import Navbar from '@/components/atomic/atoms/surfaces/navbar/styled';
import { TopNavigationItemProps } from '@/components/atomic/molecules/navigation/top-nav-items/item/typings';
import type { CSSObject } from '@emotion/react';
import styled from '@emotion/styled';

const TopNavItem = styled.li<
	Pick<TopNavigationItemProps, '$variant'> & { $hasLabel?: boolean }
>(({ theme, $variant, $hasLabel }) => {
	const style: CSSObject = {
		verticalAlign: 'top',
		height: '100%',
		[`${Navbar} &`]: {
			display: 'inline-block',
		},
		[`${theme.media.desktop.laptop}`]: {
			display: 'inline-block',
		},
		a: {
			paddingTop: 28,
			paddingBottom: 28,
			paddingLeft: 24,
			paddingRight: 24,
			backgroundColor: 'transparent',
			textDecoration: 'none',
			display: 'block',
			height: '100%',
			[`${Navbar} &`]: {
				paddingTop: 0,
				paddingBottom: 0,
				paddingLeft: 16,
				paddingRight: 16,
				[`${theme.media.desktop.sm}`]: {
					paddingLeft:
						$variant === 'primary' ? 10 : $hasLabel ? 20 : 26,
					paddingRight:
						$variant === 'primary' ? 10 : $hasLabel ? 20 : 26,
					'&[aria-expanded="true"]': {
						backgroundColor: theme.colors.brandGrayMedium,
					},
				},
				[`${SvgSprite}`]: {
					width: 16,
					height: 16,
					[`${theme.media.desktop.sm}`]: {
						width: 20,
						height: 20,
					},
					fill: 'currentColor',
					color: theme.colors.brandGrayDark,
				},
			},
			[`${Navbar} [data-hide-nav-label="true"] &`]: {
				[`${theme.media.desktop.laptop}`]: {
					paddingLeft: 26,
					paddingRight: 26,
				},
			},
			[`${theme.media.desktop.laptop}`]: {
				paddingTop: 0,
				paddingBottom: 0,
				transition: 'background-color 0.3s ease',
				'&:hover': {
					backgroundColor: theme.colors.brandGrayMedium,
				},
			},
			span: {
				textTransform: 'uppercase',
				fontWeight: 600,
				fontFamily: theme.font.families.secondary.medium,
				fontSize: $variant === 'primary' ? 20 : 14,
				lineHeight: $variant === 'primary' ? '24px' : '17.15px',
				letterSpacing: '1.76px',
				color: theme.colors.primaryBrandColor,
				whiteSpace: 'normal',
				wordWrap: 'break-word',
				[`${theme.media.desktop.laptop}`]: {
					fontFamily: theme.font.families.secondary.demiBold,
					fontSize: 11,
					lineHeight: '15px',
					letterSpacing: '1.6px',
				},
			},
			[`${Navbar} [data-hide-nav-label] & ${FlexContainer}`]: {
				transition: 'var(--nav-transition, none)',
			},
			[`${Navbar} [data-hide-nav-label="true"] & ${FlexContainer}`]: {
				gap: 0,
			},
			[`${Navbar} [data-hide-nav-label] & ${FlexItem}:not(:only-child):has(span)`]:
				{
					interpolateSize: 'allow-keywords',
					width: 'max-content',
					transitionBehavior: 'allow-discrete',
					transition: 'var(--nav-transition, none)',
				},

			[`${Navbar} [data-hide-nav-label="true"] & ${FlexItem}:not(:only-child):has(span)`]:
				{
					opacity: 0,
				},
			[`@supports not (interpolate-size: allow-keywords)`]: {
				[`${Navbar} [data-hide-nav-label] & ${FlexItem}:not(:only-child):has(span)`]:
					{
						maxWidth: 180,
					},
				[`${Navbar} [data-hide-nav-label="true"] & ${FlexItem}:not(:only-child):has(span)`]:
					{
						maxWidth: 0,
					},
			},
			[`@supports (interpolate-size: allow-keywords)`]: {
				[`${Navbar} [data-hide-nav-label] & ${FlexItem}:not(:only-child):has(span)`]:
					{
						[`@starting-style`]: {
							opacity: 1,
						},
					},
				[`${Navbar} [data-hide-nav-label="true"] & ${FlexItem}:not(:only-child):has(span)`]:
					{
						width: 0,
						display: 'none',
					},
			},
		},
	};

	return style;
});

export default TopNavItem;
